module.exports = __webpack_public_path__ + "static/media/arrow-desc.37769241.svg";